import Swiper from "swiper";
import { Navigation, Thumbs, FreeMode, Pagination } from "swiper/modules";

export default function initCarousel(): void {

    const $carouselTextImageVideoContainers = document.querySelectorAll<HTMLElement>(
        ".js-text-image-video-carousel"
    );

    $carouselTextImageVideoContainers.forEach(($container) => {
        new CarouselTextImageVideo($container);
    });
}

class CarouselTextImageVideo {
    $el: HTMLElement;
    $thumbs: HTMLElement | null;
    $display: HTMLElement | null;

    swiperThumbs: Swiper | null = null;
    swiperMain: Swiper | null = null;

    constructor($el: HTMLElement) {
        this.$el = $el;
        this.$display = $el.querySelector(".js-carousel-display");
        this.$thumbs = $el.querySelector(".js-carousel-thumbs");

        this.init();
    }

    init(): void {
        if (!this.$display || !this.$thumbs) return;


    
        const nextEl = this.$el.querySelector<HTMLElement>(".swiper-button-next");
        const prevEl = this.$el.querySelector<HTMLElement>(".swiper-button-prev");
        const paginationEl = this.$el.querySelector<HTMLElement>(".swiper-pagination");
    
        if (!nextEl || !prevEl) return;
    
        this.swiperThumbs = new Swiper(this.$thumbs, {
            modules: [FreeMode],
            spaceBetween: 9,
            slidesPerView: 4,
            freeMode: true,
            watchSlidesProgress: true,
            
        });
    
        this.swiperMain = new Swiper(this.$display, {
            modules: [Navigation, Pagination, Thumbs],
            slidesPerView: 1,
            navigation: {
                nextEl: nextEl,
                prevEl: prevEl,
            },
            pagination: {
                el: paginationEl,
                clickable: true,
            },
            thumbs: {
                swiper: this.swiperThumbs,
            },
        });
    }
}
